import React, { useEffect, useState } from 'react';
import * as R from 'ramda';

export const Path = ({ deceasedUser, declaration, serviceDatas, userLetters }) => {
    const [step, setStep] = useState(0);
    useEffect(() => {
        if(R.isNil(declaration)){
            setStep(1);
        }else if(!deceasedUser.hasCompletedDossier && deceasedUser.createdByRepresentative){
            setStep(1);
        }else{
            if(R.isNil(declaration.onBoardingStep) || declaration.onBoardingStep < 6){
                setStep(2);
            }else if(declaration.onBoardingStep === 6){
                if(userLetters.every(l => l.letterProgressStage !== "Created")){
                    setStep(4);
                }else{
                    setStep(3);
                }
            }
        }
    }, [declaration, deceasedUser, serviceDatas, userLetters])

    if(R.isNil(deceasedUser)){
        return ""
    }
    return(
        <div className="stepper order-md-first">
            <ul className="nav stepper-nav gap-xs">
                <li className={"stepper-item stepper-center" + (step === 1 ? " active" : step > 1 ? " completed" : "")}>
                    <span className="stepper-icon align-self-center">1</span>
                    <span className="stepper-title mx-auto px-0">COMPLETER</span>
                </li>
                <li className={"stepper-item stepper-center" + (step === 2 ? " active" : step > 2 ? " completed" : "")}>
                    <span className="stepper-icon align-self-center">2</span>
                    <span className="stepper-title mx-auto px-0">ACTE DE DÉCÈS</span>
                </li>
                <li className={"stepper-item stepper-center" + (step === 3 ? " active" : step > 3 ? " completed" : "")}>
                    <span className="stepper-icon align-self-center">3</span>
                    <span className="stepper-title mx-auto px-0">VALIDER</span>
                </li>
                <li className={"stepper-item stepper-center" + (step === 4 ? " active" : step > 4 ? " completed" : "")}>
                    <span className="stepper-icon align-self-center">4</span>
                    <span className="stepper-title mx-auto px-0">COURRIERS / SUIVI</span>
                </li>
            </ul>
        </div>
    )

};